import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-search-icon',
  standalone: true,
  template: `
    <svg
      [class]="iconClass()"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.16699 16.6667C13.3091 16.6667 16.667 13.3089 16.667 9.16675C16.667 5.02461 13.3091 1.66675 9.16699 1.66675C5.02486 1.66675 1.66699 5.02461 1.66699 9.16675C1.66699 13.3089 5.02486 16.6667 9.16699 16.6667Z"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M15.775 17.2416C16.2167 18.5749 17.225 18.7083 18 17.5416C18.7084 16.4749 18.2417 15.5999 16.9584 15.5999C16.0084 15.5916 15.475 16.3333 15.775 17.2416Z"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class SearchIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
